/* eslint-disable no-use-before-define */

import memoize from 'memoizee';
import { retry } from './helpers';

const getGasPrice = memoize(async () => (
    (await retry(fetch('https://api.curve.finance/api/getGas'))).json()
), {
    promise: true,
    maxAge: 10 * 1000, // 10s
});

export {
    getGasPrice,
};
